<template>
  <v-row no-gutters>
    <v-col class="pa-0 font-weight-light" v-bind:class="mobileBreakPoint == true ? 'pb-2':''">
      <v-text-field
        append-icon="mdi-magnify"
        color="primary"
        single-line
        hide-details
        dense
        outlined
        :label="labels.search"
        v-model="search"
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import translate from '@/utils/genTable/multilanguageHelper.js'
import store from '@/store/store'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'RealTimeSearchComponent',
  props: ['poiView', 'mobileBreakPoint'],
  data() {
    return {
      search: '',
      labels: {
        search: translate('Search', 'mapFilters')
      }
    }
  },
  computed: {
    ...mapState('map', ['vehicles', 'selectedPois', 'realTimeRoutes']),
    ...mapGetters('filters', ['getFilterFunction'])
  },
  watch: {
    search: {
      handler() {
        store.dispatch('filters/setKeyword', this.search)
        this.getFilterFunction.forEach(fnc => {
          fnc(this.vehicles, this.realTimeRoutes)
        })
      }
    }
  }
}
</script>
